import { render, staticRenderFns } from "./couponOrderInfo.vue?vue&type=template&id=44376331&scoped=true&"
import script from "./couponOrderInfo.vue?vue&type=script&lang=js&"
export * from "./couponOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./couponOrderInfo.vue?vue&type=style&index=0&id=44376331&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44376331",
  null
  
)

export default component.exports